module.exports = __webpack_public_path__ + "static/media/scrollright_mobile.6d8ca321.jpg";